import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';

/**
 * "Onaya Gönder": yolcu adımı (UpdatePassengers → Billing/Submit → (MakePrebooking))
 * tamamlanıp bir sonraki adıma geçtiğinde — rezervasyon artık yöneticinin onayında —
 * kullanıcıya bilgi verip akıştan çıkarır: snackbar + `flow.reset()` + rezervasyon listesine
 * yönlendirme. `AirFlowPage`'deki inline effect'ten çıkarıldı; beş ürün modülü de kullanır.
 */
export function useSentForApproval(opts: {
  /** `flow.state.sentForApproval` */
  sent: boolean;
  /** `flow.status === 'idle'` */
  idle: boolean;
  /** `flow.currentStep?.id` */
  currentStepId: string | undefined;
  /** Bu modülün yolcu adımının id'si — akış bunun ötesine geçince effect tetiklenir. */
  passengerStepId: string;
  /** Yönlendirme hedefi, örn. `/air/reservations`. */
  reservationPath: string;
  /** `flow.reset` */
  reset: () => void;
  message?: string;
}): void {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const done = opts.sent && opts.idle && opts.currentStepId !== opts.passengerStepId;

  useEffect(() => {
    if (!done) return;
    enqueueSnackbar(
      opts.message ??
        'Rezervasyon onaya gönderilmiştir. Yöneticiniz onayladığında rezervasyon listenizden ödemeye devam edebilirsiniz.',
      { variant: 'success' }
    );
    opts.reset();
    navigate(opts.reservationPath, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [done]);
}
